import { render, staticRenderFns } from "./CrearReservaViaje.vue?vue&type=template&id=2aa80f34&scoped=true"
import script from "./CrearReservaViaje.vue?vue&type=script&lang=js"
export * from "./CrearReservaViaje.vue?vue&type=script&lang=js"
import style0 from "./CrearReservaViaje.vue?vue&type=style&index=0&id=2aa80f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa80f34",
  null
  
)

export default component.exports